"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = exports.PredictedCapitalizationStatus = void 0;
var PredictedCapitalizationStatus;
(function (PredictedCapitalizationStatus) {
    PredictedCapitalizationStatus["CAPITALIZABLE"] = "CAPITALIZABLE";
    PredictedCapitalizationStatus["NOT_CAPITALIZABLE"] = "NOT_CAPITALIZABLE";
    PredictedCapitalizationStatus["UNCERTAIN"] = "UNCERTAIN";
})(PredictedCapitalizationStatus || (exports.PredictedCapitalizationStatus = PredictedCapitalizationStatus = {}));
exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = {
    [PredictedCapitalizationStatus.CAPITALIZABLE]: 'Capitalizable',
    [PredictedCapitalizationStatus.NOT_CAPITALIZABLE]: 'Not Capitalizable',
    [PredictedCapitalizationStatus.UNCERTAIN]: 'Uncertain',
};
